import { NgModule }        from '@angular/core';
import { StringClampPipe } from './string-clamp.pipe';

@NgModule({
  declarations: [StringClampPipe],
  exports: [StringClampPipe]
})
export class StringClampModule {
}
